import styled from 'styled-components';
import { media, Row, Column } from '@simplywallst/ui-core';
import LogoWhiteSVG from '@assets/images/logo/sws-logo-white.svg';
import {
  getCloudflareImageUrl,
  getStaticUrl,
} from '@/hooks/useCloudflareImage';
interface SplashPanelWrapperProps {
  introducing: boolean;
}

export const SplashPanelWrapper = styled(Column)<SplashPanelWrapperProps>`
  position: relative;
  background-image: url(${getCloudflareImageUrl({
    src: getStaticUrl('background.jpg'),
    width: 560,
    height: 652,
    fit: 'cover',
  })});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left bottom;
  ${media.lgUp`
    background-position: left top;
  `}
  color: white;
  ${media.mdDown`
    ${({ introducing }) => introducing === false && `display: none;`}
  `}
`;

export const SplashPanelIntroduction = styled('header')`
  padding: ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    padding-top: ${({ theme }) => theme.x10space * 10}px;
  `}
  text-align: center;
`;

export const IntroductionHeader = styled('h1')`
  ${({ theme }) => theme.typography.small}
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.x1space}rem;
`;

export const IntroductionBody = styled('div')`
  ${({ theme }) => theme.typography.small}
  ${media.lgUp`
    display: none;
  `}
  > p {
    margin-bottom: ${({ theme }) => theme.x1space}rem;
  }
  ${media.xsOnly`
    > * {
      font-size: ${({ theme }) => theme.x2space - 0.3}rem;
    }
  `}
`;

export const HelpLinks = styled('footer')`
  ${media.mdDown`
    display: none;
  `}
  position: absolute;
  bottom: ${({ theme }) => theme.x4spacePx}px;
  left: ${({ theme }) => theme.x4spacePx}px;
  font-size: ${({ theme }) => theme.x2space - 0.2}rem;
  > a {
    margin-right: ${({ theme }) => theme.x2spacePx}px;
  }
`;

export const Bullets = styled(Column)`
  counter-reset: bullet;
  padding-left: ${({ theme }) => theme.x4spacePx}px;
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  > li {
    position: relative;
    margin-bottom: ${({ theme }) => theme.x2spacePx}px;
    &:before {
      position: absolute;
      left: -${({ theme }) => theme.x4spacePx}px;
      opacity: 0.3;
      font-size: 28px;
      counter-increment: bullet;
      content: counter(bullet);
      line-height: 1;
      font-weight: 300;
    }
  }
`;

export const PhoneWrapper = styled(Column)`
  padding-left: ${({ theme }) => theme.x3spacePx}px;
`;

export const Phone = styled('div')`
  width: 100%;
  padding-top: 166%;
  background: url('${getCloudflareImageUrl({
      src: getStaticUrl('phone-screen.png'),
      width: 224,
      height: 371,
    })}')
    right bottom / cover no-repeat;
`;

export const Content = styled(Row)`
  position: absolute;
  bottom: 0;
  padding: 0 ${({ theme }) => theme.x4spacePx}px;
`;

export const SWSLogoWhite = styled(LogoWhiteSVG)`
  ${media.mdDown`
    display: none;
  `}
  width: 100%;
  max-width: 295px;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;
